<template>
    <div>
        <card-header title="WIAA Cert Search" icon="fa-search"/>

        <card-body>
            <card-list>
                <subheader-list-item :title="props.query" icon="fa-search" :badge="searchResults.length"/>
                <container-list-item padded v-if="searching" class="has-text-grey is-size-7">
                    <i class="fas fa-spinner fa-spin fa-fw mr-2 ml-2"></i>Searching...
                </container-list-item>
                <container-list-item padded v-if="!searching && searchResults.length === 0" class="has-text-grey is-size-7">
                    No users found for: "{{props.query}}"
                </container-list-item>
                
                <wiaa-certification-tile 
                    v-for="user in searchResults" 
                    :key="user.id"
                    :card="card" 
                    :user="user" 
                    :active="user.active"
                    @click="$openCard('wiaa-certification-details', {userId: user.id}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import WiaaCertificationTile from "../../components/tiles/WiaaCertificationTile";
    import {client as http} from '@/http_client';

    export default {
        components: {
            ContainerListItem, 
            CardHeader, 
            CardBody, 
            CardList, 
            SubheaderListItem,
            WiaaCertificationTile
        },
        props: ['card', 'props', 'child'],
        data() {
            return {
                searchResults: [],
                searching: false
            };
        },
        methods: {
            searchCertification: function (query) {
                this.searching = true;
                this.$emit('loading', true);
                
                http.get(`wiaa/lookup/${encodeURIComponent(query)}`).then(response => {
                    this.searchResults = response.data;
                    this.setActive();
                    this.searching = false;
                    this.$emit('loading', false);
                }).catch(err => {
                    this.searching = false;
                    this.$emit('loading', false);
                    this.$buefy.toast.open({
                        message: 'Error searching for WIAA certifications',
                        type: 'is-danger',
                        duration: 3000
                    });
                });
            },
            setActive: function () {
                let check = (this.child && this.child.definition.component === 'wiaa-certification-details') ? parseInt(this.child.props.userId) : null;
                this.searchResults.map(u => u.active = (u.id === check));
            },
            reload: function () {
                if (this.props.query) {
                    this.searchCertification(this.props.query);
                }
            }
        },
        watch: {
            'child': function () {
                this.setActive();
            },
            'props': function (n, o) {
                if (n.query !== o.query) this.searchCertification(n.query);
            }
        },
        mounted: function () {
            if (this.props.query) {
                this.searchCertification(this.props.query);
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>